import { createContext, useContext } from 'react';
import { useChatStorage } from '../hooks/useChatStorage';

const ChatStorageContext = createContext();

export const ChatStorageProvider = ({ children }) => {
  const storage = useChatStorage();
  return (
    <ChatStorageContext.Provider value={storage}>
      {children}
    </ChatStorageContext.Provider>
  );
};

export const useSharedChatStorage = () => useContext(ChatStorageContext);